
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class UpgradeModal extends Vue {
  @Prop({ default: false }) value!: boolean;
  @Prop({ default: '' }) featureName!: string;
  @Prop({ default: 'Professional' }) requiredPackage!: string;
  @Prop({ default: '' }) description!: string;
  @Prop({ default: () => [] }) benefits!: string[];

  get dialog(): boolean {
    return this.value;
  }

  set dialog(val: boolean) {
    this.$emit('input', val);
  }

  close(): void {
    this.dialog = false;
  }

  learnMore(): void {
    this.$emit('learn-more', this.requiredPackage);
    this.close();
  }
}
